module.exports = "<footer-section></footer-section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/footer-section/index.html
// module id = 90
// module chunks = 0